<template>
  <b-container v-if="this.type">
    <h1 v-translate="{type: $appConfig.models[this.type].title}">Edit %{type}</h1>
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="success"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
      >
        <translate>The Item has been updated</translate>
      </b-alert>
      <b-form @submit.prevent="patchItem">
        <b-form-row
          class="mb-3"
          :id="'fieldsetHorizontal' + index"
          v-for="(field, index) in fields"
          :key="index"
        >
          <b-col sm="4" lg="3">
            <label id="fieldsetHorizontal__BV_label_" :for="'inputHorizontal'+ index" class="col-form-label">{{field.label || snakeCaseToTitleCase(field.key)}}<small class="text-danger" v-if="field.required"> *</small></label>
          </b-col>
          <b-col>
            <b-form-select v-model="item[field.key]" :options="[{value: 1, text: $gettext('Yes')}, {value: 0, text: $gettext('No')}]" :key="index" v-if="field.type === Boolean" />
            <v-jsoneditor :height="'500px'" v-model="item[field.key]" v-else-if="field.type === 'JSON'" :key="`json${index}`" :options="{modes: ['tree', 'view', 'form', 'code', 'text', 'preview'], mode: 'code'}"></v-jsoneditor>
            <b-form-input :id="'inputHorizontal'+ index" :type="field.type || 'text'" :step="field.type === 'time' && field.step ? field.step : null" v-model="item[field.key]" :disabled="!field.editable" :key="`generic${index}`" :required="field.required" v-else />
            <small tabindex="-1" class="form-text text-muted" v-if="field.description">{{field.description}}</small>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="4" lg="3">
            <label class="col-form-label" v-translate>Areas</label>
          </b-col>
          <b-col>
            <b-form-checkbox-group stacked v-model="item.areas" multiple :options="areasSelect" class="mb-3" :select-size="10">
            </b-form-checkbox-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-button type="submit" variant="primary" v-translate>Submit</b-button>
          </b-col>
          <b-col class="text-right" v-if="this.$appConfig.models[this.type].allowDelete">
            <b-button @click.stop="deleteItem" variant="danger" v-translate>DELETE Item</b-button>
          </b-col>
        </b-form-row>
      </b-form>
  </b-container>
</template>
<script>
import VJsoneditor from 'v-jsoneditor/src/index'

export default {
  name: 'RegionEdit',
  components: {
    VJsoneditor
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'regions'
    },
    id: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {
      fields: this.$appConfig.models[this.type].fields,
      item: {
        areas: []
      },
      success: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      originalAreas: []
    }
  },
  watch: {
    type: function (val) {
      this.fields = this.$appConfig.models[this.type].fields
    }
  },
  mounted() {
    this.getItem()
  },
  methods: {
    getItem() {
      this.$http.get(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id, { params: {includes: ['areas']} })
        .then(response => {
          this.item = response.body
          this.item.areas = this.item.areas.length > 0 ? this.item.areas.map(x => { return x.id }) : []
          this.originalAreas = [...new Set(this.item.areas)]
          this.fetchAreas(this.item.country_iso_code, ['regions'])
            .then(response => {
              this.areasSelect = this.areas.map(x => {
                let area = {
                  text: x.name,
                  value: x.id
                }
                let inUseIndex = x.regions.findIndex(y => y.type === this.item.type)
                if (inUseIndex !== -1 && x.regions[inUseIndex].id !== this.item.id) {
                  area.disabled = true
                }
                return area
              })
            })
        })
    },
    patchItem() {
      let toPatch = {}
      for (let field in this.fields) {
        if (this.fields[field].editable) {
          toPatch[this.fields[field].key] = this.item[this.fields[field].key]
        }
        if (this.fields[field].editable && this.fields[field].toLowerCase) {
          toPatch[this.fields[field].key] = toPatch[this.fields[field].key].toLowerCase()
        }
      }
      this.$http.patch(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id, toPatch)
        .then(response => {
          if (this.originalAreas.length > 0) {
            this.$http.delete(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id + '/areas', {body: {areas: this.originalAreas}})
              .then(response => {
                this.$http.post(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id + '/areas', this.item)
                  .then(response => {
                    this.showAlert()
                    this.getItem()
                  })
              })
          } else if (this.item.areas.length > 0) {
            this.$http.post(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id + '/areas', this.item)
              .then(response => {
                this.showAlert()
                this.getItem()
              })
          } else {
            this.showAlert()
            this.getItem()
          }
        })
    },
    deleteItem() {
      if (
        confirm(this.$gettextInterpolate(this.$gettext('Are you sure you want to DELETE the row with ID:\n%{id}\nWARNING: THIS ACTION CANNOT BE UNDONE!'), {id: this.id}))
      ) {
        this.$http.delete(this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint + '/' + this.id)
          .then(response => {
            this.$router.push('/list/' + this.$appConfig.models[this.type].endpoint, { query: { deleted: true } })
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    snakeCaseToTitleCase(str) {
      return str.replace(/_/g, ' ').replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        }
      )
    }
  }
}
</script>
